export default __webpack_public_path__ + "static/media/pngwing.f6cc872a.png";